import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import * as Yup from "yup";
import { connect } from "react-redux";
import { ROUTESLIST } from "@/static/urls";

import GoogleIcon from "@/assets/images/google-icon.png";
import AppleIcon from "@/assets/images/apple-icon.png";
import { withAuth0 } from "@auth0/auth0-react";
import { toast } from "react-toastify";
import FormField from "../../components/forms/form-field";
import PasswordField from "../../components/forms/password-field";
import CheckboxField from "../../components/forms/checkbox-field";
import { getToken, fetchCurrentUser } from "@/actions/auth";
import { bindActionCreators } from "redux";
import OurClients from "../../components/our-clients";
import Testimonials from "../../components/testimonials";

const bgStyles = {
  //   backgroundImage: `url(${BgImage})`,
  //   backgroundRepeat: "no-repeat",
  //   backgroundPosition: "center",
  //   backgroundSize: "cover",
  background: "#000",
};

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.submitForm = this.submitForm.bind(this);
    this.state = {
      redirectToHome: false,
    };
  }

  loginWithGoogle = async () => {
    try {
      await this.props.auth0?.loginWithRedirect({
        authorizationParams: {
          connection: "google-oauth2",
          screen_hint: "login",
        },
      });
      window.dispatchEvent(new Event("storage"));
      console.log('------',this.props.auth0)
    } catch (error) {
      console.error("Google Login Error:", error);
    }
  };

  loginWithApple = async () => {
    try {
      await this.props.auth0?.loginWithRedirect({
        authorizationParams: { connection: "apple", screen_hint: "signup" },
      });
    } catch (error) {
      console.error("Apple Login Error:", error);
    }
  };

  componentDidMount() {
    const token = localStorage.getItem("access_token");
    console.log("Token from localStorage:", token);
    if (token) {
      this.setState({
        redirectToHome: true,
      });
    }
  }
  async submitForm(data) {
    const { email, password } = data;

    const domain = "amplesamples.auth0.com";
    const client_id = "EvFIfHHpNpJoDa6lcZ0IH9mY7me3yKs8";
    const client_secret = "1G_QMP-kzSVcLjiXIsInLSVb0J7jLngtMGIMN7h-Jf15coyI8NNmd_4gTVHtUCA-";

    try {
      // Step 1: Login the user
      const loginResponse = await fetch(`https://${domain}/oauth/token`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          grant_type: "password",
          username: email,
          password: password,
          client_id: client_id,
          client_secret: client_secret,
          realm: "Username-Password-Authentication",
          audience: `https://${domain}/api/v2/`,
          scope: "openid profile email",
        }),
      });

      const signupData = await loginResponse.json();

      console.log("✅ Login Success: ", signupData);

      if (!loginResponse.ok) {
        throw new Error(signupData.error_description || "Login failed");
      } else {
        toast.success("Login successful");
        localStorage.setItem("useData", JSON.stringify(signupData));

        localStorage.setItem("isIdentityLogin", true);
        localStorage.setItem("token", signupData?.access_token);
        localStorage.setItem("id_token", signupData?.id_token);
        localStorage.setItem("access_token", signupData?.access_token)
        localStorage.setItem("isAuthenticated", true);
        window.dispatchEvent(new Event("storage"));
        // signupData?.access_token?.length && this.props?.getToken(signupData?.access_token);

        let isGuestUser = false;
        try {
          const userData = await this.props.fetchCurrentUser();
          isGuestUser = !!userData?.is_guest;
        } catch (e) {
          console.error("Failed to fetch user data; proceeding as non-guest:", e);
        }

        const response = await fetch(`https://${domain}/userinfo`, {
          headers: {
            Authorization: `Bearer ${signupData?.access_token}`,
          },
        });

        if (!response.ok) {
          console.error("Failed to fetch user info");
          this.props.history.push(ROUTESLIST.LOGIN);
          return;
        }

        const userInfo = await response.json();
        userInfo.isGuest = isGuestUser;
        localStorage.setItem("userInfo", JSON.stringify(userInfo));

        if (userInfo.isGuest) {
          this.props.history.push(ROUTESLIST.ACCOUNT_CHANGE_PASSWORD);
        } else {
          this.props.history.push(ROUTESLIST.CLEAR_SAMPLE);
        }
      }
    } catch (err) {
      console.error("Login Error:", err);
      toast.error("Error: " + err.message);
    }
  }
  componentWillUnmount() {}

  render() {
    const { handleSubmit, pristine, submitting } = this.props; //submitLogin
    // return <Redirect to={`clear-sample`} />;
    // return this.props.history.push("clear-sample");

    // if (redirectToHome) {
    //   return <Redirect to="/" />;
    // }

    return (
      <main className="page">
        <section
          // className="form-section form-section--radial"
          style={bgStyles}
        >
          <div className="content">
            <div className="front-banner">
              <img
                src="https://ample-samples.s3.us-east-2.amazonaws.com/app/front-banner.svg"
                alt="front-banner"
                className="banner-image"
              />
              <h3 className="front-header">Login to your Account</h3>
              <p className="front-paragraph">
                You make the music, and leave the clearance problems to us!
              </p>
              {/* <button className="btn-width">Join now</button> */}
            </div>
          </div>
          <div className="content">
            <div className="review-video">
              <div className="review-video__inner">
                <iframe
                  width="560"
                  height="315"
                  src="https://www.youtube.com/embed/5hqbvLuArkE"
                  title="YouTube video player"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          <div className="content-tight">
            {/* <h3 className="head-middle">Log In to continue</h3> */}

            <div className="outer-signup">
              <h3 className="outer-header">Login with</h3>
              <button className="outer-button" onClick={this.loginWithGoogle}>
                <img src={GoogleIcon} alt="Google" />
                <span>Login with Google</span>
              </button>
              <button className="outer-button" onClick={this.loginWithApple}>
                <img src={AppleIcon}  alt="Apple"/>
                <span>Login with Apple</span>
              </button>
            </div>
            <div className="divider">
              <span>OR</span>
            </div>
            <form
              onSubmit={handleSubmit(this.submitForm)}
              className="login-form signup-form"
              noValidate
            >
              <Field
                name="email"
                component={FormField}
                type="text"
                // placeholder="some@email.com"
                label="Username / Email"
              />
              <Field
                name="password"
                component={PasswordField}
                type="password"
                label="Password"
              />
              <div className="form-row form-row_sided">
                <div className="form-col form-col_half">
                  <div className="form-field">
                    <Field
                      name="remember"
                      component={CheckboxField}
                      label="Remember Me"
                    />
                  </div>
                </div>
                <div className="form-col form-col_half">
                  <div className="form-field">
                    <Link
                      to={ROUTESLIST.ACCOUNT_FORGOT_PASSWORD}
                      className="link"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                </div>
              </div>
              <div className="form-submit-row">
                <button
                  className="btn btn-primary btn-fw"
                  disabled={pristine || submitting}
                  type="submit"

                  // onClick={() => {
                  //   this.setState({
                  //     redirectToSubscription: true
                  //   })
                  // }}
                >
                  Log In
                </button>
              </div>
            </form>
            <div className="form-field center">
              Don’t have an account yet?{" "}
              <Link to="/signup" className="link">
                Create One.
              </Link>
            </div>
          </div>
          <Testimonials />
          <OurClients />
        </section>
      </main>
    );
  }
}

const validationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
  password: Yup.string()
    .required("Password is required")
    .min(
      8,
      "Password must contain 8 or more characters with at least one of each: uppercase, lowercase, number, and special"
    )
    .matches(/[a-z]/, "Password must contain at least 1 lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least 1 uppercase letter")
    .matches(/[0-9]/, "Password must contain at least 1 number")
    .matches(/[\W_]/, "Password must contain at least 1 special character"),
  // remember: Yup.boolean()
  //   .oneOf([true], "You must agree to the terms")
  //   .required("You must agree to the terms"),
});

// Function to validate Redux Form fields using Yup
const validate = (values) => {
  try {
    validationSchema.validateSync(values, { abortEarly: false });
    return {};
  } catch (error) {
    return error.inner.reduce((errors, err) => {
      errors[err.path] = err.message;
      return errors;
    }, {});
  }
};

// Apply redux-form and HOC
const loginFormPage = reduxForm({
  form: "login-form",
  validate, // Add validation function here
})(LoginPage);

// Map Redux state to props
const mapStateToProps = (state) => ({
  auth: state.auth,
});

// Map Redux actions to props
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToken,
      fetchCurrentUser,
    },
    dispatch
  );

// Connect Redux to component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(loginFormPage));
